import React, { PureComponent } from "react";
import styled from 'styled-components';
import PropTypes from "prop-types";
import { hot } from "react-hot-loader";
import BannerManager from "core/components/BannerNotification/BannerManager";
import { HeaderTop, BottomNav, MobileCategories } from "./components";
import userProps from "./components/HeaderTop/userProps";
import { ResponsiveCheck } from 'core/providers/Responsive';
import { StyleVars } from 'core/utils/Styles';

const HeaderContainer = styled.div`
	position: relative;
	background: white;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
	z-index: 1001;
	width: 100%;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		box-shadow: none;
	}
`;

class Header extends PureComponent {
	state = {
		bottomEnabled: true
	};

	toggleBottomEnabled = bottomEnabled => {
		this.setState({ bottomEnabled });
	};

	render() {
		const {
			user,
			bottomNavProps,
			cartCount,
			contentful,
			searchEmptyState,
			path,
		} = this.props;
		const { toggleBottomEnabled } = this;
		const { bottomEnabled } = this.state;
		const BURGER_ID = "burger-trigger";

		return (
			<ResponsiveCheck>
				{({ isMobile }) => (
					<HeaderContainer>
						<BannerManager />
						<HeaderTop
							toggleBottomEnabled={toggleBottomEnabled}
							user={user}
							burgerId={BURGER_ID}
							cartCount={cartCount}
							searchEmptyState={searchEmptyState}
							path={path}
						/>
						{isMobile ? (
							<MobileCategories
								burgerId={BURGER_ID}
								{...bottomNavProps}
								user={user}
							/>
						) : (
							<BottomNav
								contentful={contentful}
								enabled={bottomEnabled}
								toggleBottomEnabled={toggleBottomEnabled}
								{...bottomNavProps}
							/>
						)}
					</HeaderContainer>
				)}
			</ResponsiveCheck>
		);
	}

	static propTypes = {
		user: userProps,
		bottomNavProps: PropTypes.object,
		cartCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		contentful: PropTypes.bool,
		searchEmptyState: PropTypes.array,
		path: PropTypes.string,
	};
}

export default hot(module)(Header);
